import {spacing, spacingType} from '../css'

const
    type = spacingType,
    margin = value => spacing('margin', value)

export {margin, type}
